import React from "react";
import classes from "./Contact1.module.css";
import { FaUser, FaPhone, FaEnvelope, FaComment } from "react-icons/fa";
import { FaHouseDamage, FaAddressCard, FaList, FaAddressBook, FaInstagram, FaFacebook, FaLinkedin, FaYoutube, FaWhatsapp } from "react-icons/fa";


import a from "./../../Assest/cs.png";

const Contact1 = () => {
  return (
    <div>
      <div className={classes.tc}>
        <div className={classes.tc1}>
          <div className={classes.container}>
            <div className="mb-4">
              <img src={a} alt="RCG Logo" className={classes.logo} />
            </div>

            <h1 className={classes.title}>CORPORATE OFFICE</h1>
            <h2 className={classes.subtitle}>RUSHIKESH CAREER GUIDENCE</h2>
            <p className={classes.address}>PUNE, 411009</p>

            <br />

            <a href="tel:+917620582520" className={classes.sp}>
              <p className={classes.contact}>Contact: +91 7620582520</p>
            </a>

            <a href="mailto:help.rcginfo@gmail.com" className={classes.sp}>
              <p className={classes.contact}>Mail: help.rcginfo@gmail.com</p>
            </a>

            <a href="https://wa.me/917620582520" className={classes.sp}>
              <p className={classes.contact}>Whatsapp: +91 7620582520</p>
            </a>

                    <div className={classes.yz}>

                           <a href="https://www.instagram.com/rcg_counselling?igsh=eG1pbGR4YXNkZXdq"> <FaInstagram className={classes.icon3} /></a>
                              <a href="https://www.facebook.com/share/1XZKZQ3v3X/">  <FaFacebook className={classes.icon3} /></a>
                               <a href="https://youtube.com/@rcg_counselling?si=sQjGAsxA-zwTwkKd"> <FaYoutube className={classes.icon3} /></a>
                              <a href="https://wa.me/+917620582520">  <FaWhatsapp className={classes.icon3} /></a>
                               <a> <FaLinkedin className={classes.icon3} /></a>



                        </div>
          </div>
        </div>

        {/* ================= FORM ================= */}
        <div className={classes.tc2}>
          <form
            className={classes.form}
            action="https://formsubmit.co/help.rcginfo@gmail.com"
            method="POST"
          >
            <h1 className={classes.title2}>Please Feel Free To Ask</h1>

            <div className={classes.inputGroup}>
              <FaUser className={classes.icon} />
              <input
                type="text"
                className={classes.input}
                placeholder="Your Name"
                required
              />
            </div>

            <div className={classes.inputGroup}>
              <FaPhone className={classes.icon} />
              <input
                type="tel"
                className={classes.input}
                placeholder="Mobile Number"
                pattern="[0-9]{10}"
                required
              />
            </div>

            <div className={classes.inputGroup}>
              <FaEnvelope className={classes.icon} />
              <input
                type="email"
                className={classes.input}
                placeholder="Your Email"
                required
              />
            </div>

            {/* 🔽 Exam Dropdown */}
            <div className={classes.inputGroup}>
              <FaComment className={classes.icon} />
              <select className={classes.select} required>
                <option value="">Select Exam</option>
                <option value="neet">NEET</option>
                <option value="jee">JEE</option>
                <option value="cet">CET</option>
              </select>
            </div>

            <div className={classes.inputGroup}>
              <FaComment className={classes.icon} />
              <input
                type="text"
                className={classes.input}
                placeholder="Your Location"
                required
              />
            </div>

            <button type="submit" className={classes.hif}>
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact1;
